export function minLength(value, len) {
  if (value) {
    return value.length >= len ? true : false;
  } else {
    return false;
  }
}
